import { S, singleQuiz, multiQuiz, opt } from './schema.js';

const ABC = (a, b, c) => [opt('A', a), opt('B', b), opt('C', c)];

export const COFRE = {
  id: 'cofre-quantico',
  order: 2,
  title: 'Cofre Quântico',
  mission: 'Missão Cofre Quântico',
  level: 'Intermediário',
  courseLabel: 'Curso 2 de 3',
  kicker: 'Pré-requisito: certificado do Curso 1',
  startLabel: 'Abrir o cofre com a Teca',
  nextCourseId: 'rede-nebulosa',
  nextButtonLabel: 'Começar o Curso 3',
  certName: 'Curso 2 · Intermediário · Missão Cofre Quântico',
  certBody:
    'Carga: 30 slides · dado sensível, credenciais, RIPD, Encarregado, incidente (3 dias úteis). Este certificado libera o Curso 3.',
  theme: 'cofre',
  slides: [
    S(
      1,
      'O cofre existe porque o escudo não basta',
      'teca-cadeado',
      'Você já sabe o que é dado pessoal. Agora o nível sobe: saúde, biometria, senha, vazamento. 20 minutos. O cofre não abre com a mesma chave do escudo.',
      'Abrir o cofre com a Teca',
      {
        type: 'hero',
        heading: 'Missão Cofre Quântico',
        kicker: 'Curso 2 de 3',
        badge: 'cadeado teal',
      },
    ),
    S(
      2,
      'A Vaza achou um post-it',
      'teca-alerta',
      'Nexo achou senha da retaguarda no monitor da Padaria Estrela. A Vaza não precisa hackear se a gente entrega a chave. Hoje o cofre é senha, dado sensível e o alarme de vazamento.',
      'Trancar agora',
      {
        type: 'callout',
        body: 'Senha no post-it do monitor. A Vaza agradece.',
      },
      { nexo: true, vaza: true },
    ),
    S(
      3,
      'Dado sensível não é “dado importante”',
      'teca-explica',
      'Sensível, na lei, é um tipo: saúde, vida sexual, origem racial, religião, opinião política, dado genético, biometria, filiação a sindicato. Não é “tudo que a gente gosta de esconder”.',
      'Continuar',
      {
        type: 'cards',
        items: [
          { title: 'saúde', body: 'atestado, alergia, ficha médica' },
          { title: 'biometria', body: 'face, digital, voz' },
          { title: 'origem racial', body: 'tipo legal, não palpite' },
          { title: 'religião', body: 'tipo legal' },
          { title: 'opinião política', body: 'tipo legal' },
          { title: 'dado genético', body: 'tipo legal' },
          { title: 'vida sexual', body: 'tipo legal' },
          { title: 'sindicato', body: 'filiação' },
          { title: 'salário', body: 'pessoal e grave — não é automaticamente o tipo “sensível”', struck: true },
        ],
      },
    ),
    S(
      4,
      'Por que a lei aperta aqui',
      'teca-explica',
      'Com dado sensível dá para discriminar. Por isso as chaves são outras, mais estreitas. Atestado médico no grupo do RH, foto de catraca com face, ficha de alergia no cardápio: pare e pergunte.',
      'Continuar',
      {
        type: 'callout',
        body: 'Alergia de cliente no pedido pode ser dado de saúde. Não vai para o grupo da cozinha no WhatsApp pessoal.',
      },
    ),
    S(
      5,
      'Senha, token, código do SMS',
      'teca-cadeado',
      'Senha não é “dado de cliente”, mas é a chave do cofre. Token de API, código de e-mail, chave de banco: se vaza, a Vaza entra com o seu crachá.',
      'Continuar',
      {
        type: 'dont',
        items: ['Nunca no Slack', 'Nunca no post-it', 'Nunca no print da tela'],
      },
    ),
    S(
      6,
      'Need-to-know',
      'teca-explica',
      'Você vê o dado que a função pede. Suporte não baixa a base inteira “para investigar”. BI não exporta CPF se o gráfico não precisa. Colega curioso não é autorização.',
      'Continuar',
      {
        type: 'callout',
        body: 'Acesso de produção é crachá, não favor.',
      },
    ),
    S(
      7,
      'No seu posto',
      'teca-alerta',
      'Gerenciador de senha. Tela bloqueada. 2 fatores ligado. Se colou credencial no chat por acidente: avisa na hora. Apagar a mensagem não apaga o vazamento.',
      'Continuar',
      {
        type: 'checklist',
        items: [
          'Gerenciador de senha',
          'Tela bloqueada',
          '2 fatores ligado',
          'Credencial no chat: avisa na hora',
        ],
      },
    ),
    S(
      8,
      'Recap da mini-aula 1',
      'teca-explica',
      'Sensível é um tipo legal, não um adjetivo. Senha é chave do cofre. Só vê quem precisa. Vazar credencial se avisa, não se esconde.',
      'Me pergunta',
      {
        type: 'pills',
        items: ['tipo legal', 'senha = chave', 'need-to-know', 'avisa, não esconde'],
      },
    ),
    S(
      9,
      'Pergunta 1',
      'teca-pensa',
      'Ficha de alergia grave da criança no pedido. Pode ir no grupo de WhatsApp da cozinha, no celular pessoal?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'Ficha de alergia grave da criança no pedido. Pode ir no grupo de WhatsApp da cozinha, no celular pessoal?',
        scored: singleQuiz({
          items: ['c2-q1'],
          options: ABC(
            'Sim, a cozinha precisa saber',
            'A cozinha precisa saber no canal da operação, não no WhatsApp pessoal. Isso pode ser dado de saúde',
            'Não precisa avisar ninguém, LGPD proíbe',
          ),
          correct: 'B',
          gabaritoCerto:
            'Proteger a vida da criança e proteger o dado andam juntos. Canal certo, não o grupo da família da equipe.',
          gabaritoErrado:
            'Proteger a vida da criança e proteger o dado andam juntos. Canal certo, não o grupo da família da equipe.',
        }),
      },
    ),
    S(
      10,
      'Pergunta 2',
      'teca-pensa',
      'Você colou a senha do banco de homolog no Slack e apagou 10 segundos depois. E agora?',
      'Segunda volta',
      { type: 'quiz' },
      {
        prompt:
          'Você colou a senha do banco de homolog no Slack e apagou 10 segundos depois. E agora?',
        scored: singleQuiz({
          items: ['c2-q2'],
          options: ABC(
            'Apagou, está resolvido',
            'Avisa o time de segurança / Encarregado. A mensagem pode ter sido lida ou indexada',
            'Só avisa se alguém responder',
          ),
          correct: 'B',
          gabaritoCerto:
            'Apagar o post não recolhe o dado. O cofre pede alarme, não borracha.',
          gabaritoErrado:
            'Apagar o post não recolhe o dado. O cofre pede alarme, não borracha.',
        }),
      },
    ),
    S(
      11,
      'RIPD, sem susto',
      'teca-explica',
      'RIPD é o caderno do controlador: “vamos tratar dado que pode machucar direitos das pessoas? Então escreve o risco e o que vocês fazem para reduzir”. A ANPD pode pedir, principalmente com dado sensível.',
      'Continuar',
      {
        type: 'steps',
        items: ['que dado', 'como coleta e protege', 'o que reduz o risco'],
      },
    ),
    S(
      12,
      'Quem escreve, quem lê',
      'teca-explica',
      'Você não precisa redigir o RIPD. Precisa avisar quando alguém inventar um tratamento novo de alto risco: reconhecimento facial na catraca, score de cliente, dado de saúde no app.',
      'Continuar',
      {
        type: 'callout',
        body: 'Projeto novo com dado de gente → chama o Encarregado antes do go-live.',
      },
    ),
    S(
      13,
      'Encarregado (DPO)',
      'teca-explica',
      'O Encarregado é o ponto de contato da pessoa e da ANPD. Também orienta a gente. Conformidade continua da empresa, não da pessoa física dele. Não precisa de “certificado DPO” para exercer o papel.',
      'Continuar',
      {
        type: 'cards',
        items: [
          { title: 'Canal', body: 'pessoa e ANPD falam com ele' },
          { title: 'Orientação', body: 'ele ensina o time' },
          { title: 'Não é o dono da culpa', body: 'a empresa continua responsável' },
        ],
      },
    ),
    S(
      14,
      'Segurança que a lei pede',
      'teca-cadeado',
      'A lei manda medida técnica e administrativa: acesso controlado, log, backup, criptografia quando couber, gente treinada. Este curso é uma dessas medidas. Badge no LinkedIn não é.',
      'Continuar',
      {
        type: 'stones',
        items: ['acesso', 'registro', 'backup', 'gente'],
      },
    ),
    S(
      15,
      'Agente de pequeno porte',
      'teca-explica',
      'Existe regra mais leve para empresa pequena. A Altec não se desenha nesse tamanho neste curso. Então: prazo cheio, dever cheio. Sem atalho.',
      'Continuar',
      {
        type: 'callout',
        body: 'Altec: prazo cheio, dever cheio. Sem atalho de pequeno porte.',
      },
    ),
    S(
      16,
      'Recap da mini-aula 2',
      'teca-explica',
      'RIPD = caderno de risco. Encarregado = canal e orientação. Segurança = medida de verdade, não poster. Altec sem atalho de pequeno porte.',
      'Me pergunta',
      {
        type: 'pills',
        items: ['RIPD', 'Encarregado', 'medida de verdade', 'sem atalho'],
      },
    ),
    S(
      17,
      'Pergunta 3',
      'teca-pensa',
      'O time quer ligar câmera com reconhecimento facial no estoque “para ver quem pega refrigerante”. Primeiro passo?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'O time quer ligar câmera com reconhecimento facial no estoque “para ver quem pega refrigerante”. Primeiro passo?',
        scored: singleQuiz({
          items: ['c2-q3'],
          options: ABC(
            'Liga e vê se funciona',
            'Para. Biometria é dado sensível. Chama o Encarregado antes',
            'Pede um aceite no mural da copa',
          ),
          correct: 'B',
          gabaritoCerto:
            'Aceite no mural não segura biometria. Alto risco entra com RIPD e gente de privacidade, não com gambiarra.',
          gabaritoErrado:
            'Aceite no mural não segura biometria. Alto risco entra com RIPD e gente de privacidade, não com gambiarra.',
        }),
      },
    ),
    S(
      18,
      'Pergunta 4',
      'teca-pensa',
      'O Encarregado existe. Isso tira a responsabilidade da Altec?',
      'Alarme',
      { type: 'quiz' },
      {
        prompt: 'O Encarregado existe. Isso tira a responsabilidade da Altec?',
        scored: singleQuiz({
          items: ['c2-q4'],
          options: ABC(
            'Sim, o DPO assume a multa',
            'Não. A empresa continua responsável. O Encarregado é canal e orientação',
            'Só se ele tiver certificação',
          ),
          correct: 'B',
          gabaritoCerto:
            'A Resolução 18/2024 é clara: o papel não exige certificação, e a conformidade é do agente.',
          gabaritoErrado:
            'A Resolução 18/2024 é clara: o papel não exige certificação, e a conformidade é do agente.',
        }),
      },
    ),
    S(
      19,
      'O que é incidente',
      'teca-incidente',
      'Incidente, na regra da ANPD, é um evento adverso confirmado que quebra confidencialidade, integridade, disponibilidade ou autenticidade do dado pessoal. Não é todo bug. É dado de gente em risco de verdade.',
      'Continuar',
      {
        type: 'stones',
        items: ['confidencialidade', 'integridade', 'disponibilidade', 'autenticidade'],
      },
    ),
    S(
      20,
      'O relógio de 3 dias úteis',
      'teca-incidente',
      'Quando a empresa sabe que dado pessoal foi afetado e há risco relevante, comunica ANPD e titular em 3 dias úteis. Operadora avisa a controladora na hora. Esconder para “resolver primeiro” come o prazo.',
      'Continuar',
      {
        type: 'clock',
        heading: '3 dias úteis',
        body: 'a partir do conhecimento de que dado pessoal foi afetado',
      },
      {
        orientation: 'Seu papel: avisar agora. Não calcular sozinho se “é relevante”.',
      },
    ),
    S(
      21,
      'O que você faz em 5 minutos',
      'teca-explica',
      '1) Para o sangramento se puder (tira o arquivo do ar, revoga a senha). 2) Não espalha o arquivo “para a galera ver”. 3) Avisa segurança + Encarregado: o quê, quando, quem, que dado. 4) Segue o roteiro. Não dá entrevista.',
      'Continuar',
      {
        type: 'steps',
        numbered: true,
        items: [
          'Para o sangramento se puder',
          'Não espalha o arquivo',
          'Avisa segurança + Encarregado',
          'Segue o roteiro. Não dá entrevista',
        ],
      },
    ),
    S(
      22,
      'Exemplos da casa',
      'teca-alerta',
      'Planilha de clientes no Slack público. Notebook da loja sumiu. Backup no Google Drive pessoal. API devolveu CPF de outro pedido. Tudo isso acende o alarme. Mesmo “só homolog” se tiver dado de gente de verdade.',
      'Continuar',
      {
        type: 'list',
        items: [
          'Planilha de clientes no Slack público',
          'Notebook da loja sumiu',
          'Backup no Google Drive pessoal',
          'API devolveu CPF de outro pedido',
        ],
      },
    ),
    S(
      23,
      'O que não é incidente (ainda)',
      'teca-explica',
      'Tentativa bloqueada, senha errada, alerta que não confirmou dado pessoal: registra, investiga. O relógio de 3 dias começa quando se confirma que dado pessoal foi afetado. Por isso avisar cedo ajuda — quem confirma é o time, não o feeling.',
      'Continuar',
      {
        type: 'callout',
        body: 'Registra e investiga. O relógio começa na confirmação.',
      },
    ),
    S(
      24,
      'Recap da mini-aula 3',
      'teca-incidente',
      'Evento confirmado + dado pessoal + risco. 3 dias úteis para ANPD e titular. Você avisa na hora. Não esconde. Não viraliza o arquivo.',
      'Prova de campo',
      {
        type: 'pills',
        items: ['confirmado', '3 dias úteis', 'avisa agora', 'não viraliza'],
      },
    ),
    S(
      25,
      'Pergunta 5',
      'teca-pensa',
      'Sexta, 18h. Você acha no Slack um CSV com 8 mil clientes (nome, telefone, CPF) num canal que qualquer um entra. Primeira ação?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'Sexta, 18h. Você acha no Slack um CSV com 8 mil clientes (nome, telefone, CPF) num canal que qualquer um entra. Primeira ação?',
        scored: singleQuiz({
          items: ['c2-q5'],
          options: ABC(
            'Espera segunda para não “assustar”',
            'Tira o arquivo do alcance que você controla, avisa segurança e Encarregado agora',
            'Baixa o CSV para “investigar em casa”',
          ),
          correct: 'B',
          gabaritoCerto:
            'O relógio não respeita expediente. Levar o CSV para casa piora o incidente.',
          gabaritoErrado:
            'O relógio não respeita expediente. Levar o CSV para casa piora o incidente.',
        }),
      },
    ),
    S(
      26,
      'Pergunta 6',
      'teca-pensa',
      'Quem comunica a ANPD em 3 dias úteis?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt: 'Quem comunica a ANPD em 3 dias úteis?',
        scored: singleQuiz({
          items: ['c2-q6'],
          options: ABC(
            'Você, pelo seu Gmail',
            'O fluxo oficial da empresa (controlador; a operadora avisa o controlador)',
            'Só se a imprensa ligar',
          ),
          correct: 'B',
          gabaritoCerto:
            'Você aciona o fluxo. Não vira porta-voz da ANPD no celular.',
          gabaritoErrado:
            'Você aciona o fluxo. Não vira porta-voz da ANPD no celular.',
        }),
      },
    ),
    S(
      27,
      'Tarefa aplicada',
      'teca-pensa',
      'Monte o recado mínimo para o Encarregado. Marque o que precisa ir no aviso.',
      'Fechar o cofre',
      { type: 'quiz' },
      {
        prompt:
          'Monte o recado mínimo para o Encarregado. Marque o que precisa ir no aviso.',
        scored: multiQuiz({
          items: [
            {
              id: 'c2-q7',
              kind: 'multi-part',
              mustInclude: ['o-que', 'quando'],
            },
            {
              id: 'c2-q8',
              kind: 'multi-part',
              mustInclude: ['tipo', 'quantas'],
            },
            {
              id: 'c2-q9',
              kind: 'multi-part',
              mustInclude: [],
              mustExclude: ['print'],
            },
          ],
          options: [
            opt('o-que', 'O que aconteceu, em uma frase'),
            opt('quando', 'Quando você soube'),
            opt('tipo', 'Que tipo de dado (ex.: CPF, telefone)'),
            opt('quantas', 'Quantas pessoas, se der para estimar'),
            opt('print', 'Print de todos os clientes para “provar”'),
          ],
          gabaritoCerto: 'Descreve o buraco. Não reenvia o tesouro.',
          gabaritoErrado: 'Descreve o buraco. Não reenvia o tesouro.',
        }),
      },
    ),
    S(
      28,
      'O que já caiu',
      'teca-explica',
      'Sensível é tipo legal. Senha se avisa se vazar. RIPD é caderno de risco. Encarregado é canal. Incidente confirmado: 3 dias úteis, você avisa agora.',
      'Continuar',
      {
        type: 'steps',
        items: [
          'sensível = tipo legal',
          'senha: avisa se vazar',
          'RIPD = caderno de risco',
          'Encarregado = canal',
          '3 dias úteis, avisa agora',
        ],
      },
    ),
    S(
      29,
      'Hábitos do cofre',
      'teca-cadeado',
      '2 fatores. Sem credencial no chat. Sem dado de saúde no WhatsApp pessoal. Projeto novo com face ou saúde: Encarregado antes. Viu vazamento: alarme, não borracha.',
      'Emitir certificado',
      {
        type: 'habits',
        items: [
          '2 fatores',
          'Sem credencial no chat',
          'Sem dado de saúde no WhatsApp pessoal',
          'Face ou saúde: Encarregado antes',
          'Vazamento: alarme, não borracha',
        ],
      },
    ),
    S(
      30,
      'Certificado Cofre Quântico',
      'teca-festeja',
      'Cofre trancado. Falta a Rede Nebulosa: planilha, nuvem fora do Brasil, decisão de máquina, criança, multa. De novo: não faça o avançado hoje. Deixa descansar.',
      'Baixar certificado',
      { type: 'certificate' },
    ),
  ],
};
